import React from "react";
import {
  PencilSquareIcon,
  CurrencyDollarIcon,
  DevicePhoneMobileIcon,
  CursorArrowRaysIcon,
} from "@heroicons/react/24/solid";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import FeatureIcon2 from "./FeatureIcon2";

function FeaturesSection(props) {
  const features = {
    // Left column
    left: [
      {
        title: "Accessible",
        description:
          "ChurchLink can be accessed anytime, anywhere, on various devices, ensuring that congregants can stay updated even when they're not physically present at the church",
        icon: DevicePhoneMobileIcon,
        iconColor: "orange",
      },
      {
        title: "Cost Effective",
        description:
          "Save money by eliminating the printing costs associated with physical bulletins, especially for churches with large congregations",
        icon: CurrencyDollarIcon,
        iconColor: "red",
      },
    ],
    // Right column
    right: [
      {
        title: "Dynamic",
        description:
          "Easily make updates and revisions, enabling churches to share real-time announcements, events, and resources with their community in a more engaging way",
        icon: PencilSquareIcon,
        iconColor: "emerald",
      },
      {
        title: "Customizable",
        description:
          "With it's thoughtfully designed set of theming options, ChurchLink can quickly be configured to fit nicely with your Church's existing branding",
        icon: CursorArrowRaysIcon,
        iconColor: "purple",
      },
    ],
  };

  return (
    <Section
      size={props.size}
      bgColor={props.bgColor}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
      textColor={props.textColor}
    >
      <div className="container">
        <div className="flex flex-col lg:flex-row lg:items-center space-y-12 lg:space-y-0 lg:space-x-20">
          <div className="lg:w-5/12 xl:w-5/12 md:py-12 space-y-10">
            <SectionHeader
              title={props.title}
              subtitle={props.subtitle}
              strapline={props.strapline}
            />
          </div>
          <div className="lg:w-7/12 xl:w-7/12 flex-none relative">
            <div className="pattern-dots opacity-10 absolute top-0 left-0 w-48 h-64 md:mt-20 transform -translate-x-10 -translate-y-10" />
            <div className="pattern-dots opacity-10 absolute bottom-0 right-0 w-48 h-64 md:mb-20 transform translate-x-10 translate-y-10" />
            <div className="relative flex flex-col md:flex-row md:space-x-6 space-y-6 md:space-y-0">
              <div className="md:w-1/2 md:mt-24 space-y-6">
                {features.left.map((feature, index) => (
                  <div
                    className="group bg-white p-5 transition ease-out duration-200 border-2 border-gray-200 rounded-2xl hover:border-gray-300"
                    key={index}
                  >
                    <FeatureIcon2 color={feature.iconColor} className="mb-6">
                      <feature.icon />
                    </FeatureIcon2>
                    <h4 className="text-lg font-bold mb-2">{feature.title}</h4>
                    <p className="leading-relaxed text-gray-600">
                      {feature.description}
                    </p>
                  </div>
                ))}
              </div>
              <div className="md:w-1/2 space-y-6">
                {features.right.map((feature, index) => (
                  <div
                    className="group bg-white p-5 transition ease-out duration-200 border-2 border-gray-200 rounded-2xl hover:border-gray-300"
                    key={index}
                  >
                    <FeatureIcon2 color={feature.iconColor} className="mb-6">
                      <feature.icon />
                    </FeatureIcon2>
                    <h4 className="text-lg font-bold mb-2">{feature.title}</h4>
                    <p className="leading-relaxed text-gray-600">
                      {feature.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
}

export default FeaturesSection;
